import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';

export const administrationRoute: Route = {
  path: 'administration',
  canActivate: [PermissionGuard],
  data: { permissions: [Permission.ADMIN] },
  loadComponent: () =>
    import('./administration.component').then((c) => c.AdministrationComponent),
  children: [
    {
      path: 'external-notification',
      loadComponent: () =>
        import('./external-notification/external-notification.component').then(
          (c) => c.ExternalNotificationComponent,
        ),
    },
    {
      path: 'field-management',
      loadComponent: () =>
        import('./field-management/field-management.component').then(
          (c) => c.FieldManagementComponent,
        ),
    },
    {
      path: 'user-management',
      loadComponent: () =>
        import('./user-management/user-management.component').then(
          (c) => c.UserManagementComponent,
        ),
    },
  ],
};
